import React from 'react';
import { Paper, Typography } from '@mui/material';

interface SectionCardProps {
  title: string;
  icon: React.ReactNode;
  children: React.ReactNode;
}

const SectionCard: React.FC<SectionCardProps> = ({ title, icon, children }) => {
  return (
    <Paper elevation={2} className="section-card">
      <div className="flex items-center gap-3 mb-4 pb-3 border-b">
        <div className="section-icon">{icon}</div>
        <Typography
          variant="subtitle2"
          className="font-medium! opacity-80! max-lg-xl:text-[18px]!"
        >
          {title}
        </Typography>
      </div>
      {children}
    </Paper>
  );
};

export default SectionCard;
